import _ from 'lodash'

import {
    CONTRACTS_TABLE_CHANGE,
    CONTRACTS_TABLE_CHANGE_REQUEST,
    CONTRACTS_TABLE_DATA_RECEIVED,
    CONTRACTS_TABLE_LOADING_TRUE,
    CONTRACTS_TABLE_LOADING_FALSE,
} from './constants'

import config from '../../../../../../../../../config'

export function contractsTableChange(module, blockKey, id, level, customData, queryParams) {
    return {
        type: CONTRACTS_TABLE_CHANGE,
        data: {
            module,
            blockKey,
            id,
            level,
            customData,
            queryParams,
        },
    }
}

export function contractsTableChangeRequest(module, blockKey, id, level, lang, token, queryParams) {
    return {
        type: CONTRACTS_TABLE_CHANGE_REQUEST(id),
        payload: {
            uri: _.get(config, `api.${module}.${blockKey}.block[1].uri`),
            qs: {
                ...queryParams,
                entId: id,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function contractsTableDataReceived(module, id, blockKey, customData) {
    return {
        type: CONTRACTS_TABLE_DATA_RECEIVED,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function contractsTableLoadingTrue(module, id, blockKey, customData) {
    return {
        type: CONTRACTS_TABLE_LOADING_TRUE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function contractsTableLoadingFalse(module, id, blockKey, customData) {
    return {
        type: CONTRACTS_TABLE_LOADING_FALSE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
